import { UsersManagement } from "@/components/members/members-overview.tsx";
import { m } from "@/paraglide/messages.js";
import {
	organizationMembersQueryOptions,
	organizationMembersStatsQueryOptions,
} from "@/services/members-service.ts";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/settings/org/members/")({
	// Gateway is a single-user product (maxUsers=1, teams=false) — there is
	// no member management surface. The lone Gateway user IS the admin.
	beforeLoad: ({ context }) => {
		if (context.auth.user?.orgPlan === "gateway") {
			throw redirect({ to: "/settings/account" });
		}
	},
	component: UsersManagement,
	loader: async ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(organizationMembersQueryOptions(0, 20, ""));
		queryClient.prefetchQuery(organizationMembersStatsQueryOptions());
	},
	head: () => ({
		meta: [{ title: pageTitle(m.members_title()) }],
	}),
});
